<template>
  <Teleport v-for="target in targets" :key="target.key" :to="target.control.parentElement">
    <span class="multi-common-field-error">
      <ErrorTooltip :text="target.message" always-visible focusable :tooltip-id="target.id + '-popup'" />
      <span :id="target.id" class="multi-common-error-description">{{ target.message }}</span>
    </span>
  </Teleport>
</template>

<script>
import ErrorTooltip from './ErrorTooltip.vue';

export default {
  components: { ErrorTooltip },
  props: { root: { default: null }, errors: { type: Object, required: true } },
  data: () => ({ markedControls: [] }),
  computed: {
    targets() {
      return Object.entries(this.errors).flatMap(([key, message]) => {
        const [stepId, index] = key.split(':');
        const control = this.root?.querySelector(`#s_${stepId}`)?.querySelectorAll('input, select, textarea')[Number(index)];
        return control?.parentElement ? [{ key, control, message, id: `multi-common-error-${stepId}-${index}` }] : [];
      });
    },
  },
  watch: {
    targets: { immediate: true, handler() { this.$nextTick(this.markControls); } },
  },
  beforeUnmount() { this.clearControls(); },
  methods: {
    clearControls() {
      for (const { control, invalid, describedBy } of this.markedControls) {
        control.classList.remove('input-error');
        if (invalid == null) control.removeAttribute('aria-invalid');
        else control.setAttribute('aria-invalid', invalid);
        if (describedBy == null) control.removeAttribute('aria-describedby');
        else control.setAttribute('aria-describedby', describedBy);
      }
      this.markedControls = [];
    },
    markControls() {
      this.clearControls();
      this.markedControls = this.targets.map(({ control, id }) => {
        const previous = { control, invalid: control.getAttribute('aria-invalid'), describedBy: control.getAttribute('aria-describedby') };
        control.classList.add('input-error');
        control.setAttribute('aria-invalid', 'true');
        control.setAttribute('aria-describedby', id);
        return previous;
      });
    },
  },
};
</script>

<style scoped>
.multi-common-field-error { display: inline-flex; align-items: center; }
.multi-common-field-error :deep(.error-icon img) { width: 18px; height: 18px; }
.multi-common-field-error :deep(.error-tooltip-container:focus-visible) { outline: 2px solid #a71930; }
.multi-common-error-description { position: absolute; width: 1px; height: 1px; overflow: hidden; clip-path: inset(50%); }
</style>
